<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('martSale.deletedItems') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('martSale.deletedItems'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-end">
          <div class="d-flex ts-space-x-3 ">
            <label class="mt-2">Status : </label>
            <a-select
              v-model="status"
              :options="isFullStatusList"
              style="width: 150px"
            ></a-select>

            <a-range-picker
              format="DD-MM-YYYY"
              :defaultValue="rangeDate"
              :defaultPickerValue="rangeDate"
              @change="dateRangeChange"
              style="width: 300px"
            >
              <template slot="renderExtraFooter"></template>
            </a-range-picker>
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block ml-2"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <Table
        :columns="columns"
        :data="resources"
        size="small"
        :loading="loading"
        highlight-row
        stripe
        max-height="700"
      >
        <template slot-scope="{ row }" slot="branch_name_en">
          {{
            row.stock_out_main ? row.stock_out_main.branch.branch_name_en : ''
          }}
        </template>
        <template slot-scope="{ row }" slot="invoice_no">
          {{ row.stock_out_main ? row.stock_out_main.invoice_no : '' }}
        </template>
        <template slot-scope="{ row }" slot="order_no">
          {{ row.stock_out_main ? row.stock_out_main.order_no : '' }}
        </template>
        <template slot-scope="{ row }" slot="customer_name">
          {{
            row.stock_out_main ? row.stock_out_main.customer.customer_name : ''
          }}
        </template>
        <template slot-scope="{ row }" slot="product_name_en">
          {{ row.product ? row.product.product_name_en : '' }}
        </template>
        <template slot-scope="{ row }" slot="uom_id">
          {{ row.uom_id ? row.uom.uom_name_en : '' }}
        </template>
      </Table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import moment from 'moment'
export default {
  name: 'DeletedItemsList',
  data() {
    return {
      loading: false,
      rangeDate: [moment().startOf('month'), moment()],
      isFullStatusList: [
        { value: '', label: 'All' },
        { value: 'Full', label: 'Full' },
        { value: 'Minus', label: 'Minus' }
      ]
    }
  },
  created() {
    this.fetchData()
  },

  computed: {
    ...mapState('martSale/deletedItemsList', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.martSale.deletedItemsList.search
      },
      set(newValue) {
        this.$store.commit('martSale/deletedItemsList/SET_SEARCH', newValue)
        this.$store.commit('martSale/deletedItemsList/RESET_CURRENT_PAGE')
      }
    },
    status: {
      get() {
        return this.$store.state.martSale.deletedItemsList.status
      },
      set(newValue) {
        this.$store.commit('martSale/deletedItemsList/SET_STATUS', newValue)
      }
    },
    columns() {
      return [
        {
          title: this.$t('martSale.branch'),
          slot: 'branch_name_en',
          width: 120
        },
        {
          title: this.$t('martSale.invoiceNo'),
          slot: 'invoice_no',
          width: 150,
          align: 'center'
        },
        {
          title: this.$t('martSale.orderNo'),
          slot: 'order_no',
          align: 'center',
          width: 120
        },
        {
          title: this.$t('martSale.numberCustomer'),
          slot: 'customer_name',
          width: 150
        },
        {
          title: this.$t('martSale.productName'),
          slot: 'product_name_en',
          width: 250
        },
        {
          title: this.$t('martSale.uom'),
          slot: 'uom_id',
          align: 'center',
          width: 120
        },
        {
          title: this.$t('martSale.quantity'),
          key: 'quantity',
          align: 'center',
          width: 120
        },
        {
          title: this.$t('martSale.status'),
          key: 'status',
          align: 'center',
          width: 120
        },
        {
          title: this.$t('martSale.dateDeleted'),
          key: 'created_date',
          width: 200
        }
      ]
    }
  },

  methods: {
    fetchData(attributes = {}) {
      this.loading = true
      this.$store
        .dispatch(
          'martSale/deletedItemsList/fetch',
          Object.assign({}, { branch_id: this.branch_id }, attributes)
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    dateRangeChange(dateRange) {
      if (dateRange && dateRange.length > 0) {
        this.$store.commit(
          'martSale/deletedItemsList/SET_DATE_FROM',
          dateRange[0].format('DD-MM-YYYY')
        )
        this.$store.commit(
          'martSale/deletedItemsList/SET_DATE_TO',
          dateRange[1].format('DD-MM-YYYY')
        )
      } else {
        this.$store.commit('martSale/deletedItemsList/SET_DATE_FROM', null)
        this.$store.commit('martSale/deletedItemsList/SET_DATE_TO', null)
      }
      this.fetchData()
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search, branch_id: this.branch_id })
    }, 500),
    status: debounce(function() {
      this.fetchData({ branch_id: this.branch_id })
    }, 500),
    branch_id: debounce(function(value) {
      this.fetchData({ branch_id: value })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('martSale/deletedItemsList/RESET_STATE')
    next()
  }
}
</script>
